/**
 * Default PRONAF project template.
 * Mirrors the spreadsheet structure so forms bind consistently.
 */
export const DEFAULT_PROJECT = {
  basic_data: {
    agencia_beneficiario: "",
    conta_corrente: "",
    data: new Date().toISOString().slice(0, 10),
    agencia_assentamento: "",
    assentamento: "",
    municipio: "",
  },
  applicant: { nome: "", cpf: "", estado_civil: "", sipra: "" },
  spouse: { nome: "", cpf: "", estado_civil: "", sipra: "" },
  ates: { nome: "", crea_crmv: "" },

  credit: {
    contratacao: "1ª",
    items: [{ quantidade: 1, especificacao: "", valor_unitario: 0 }],
    total_itens: 0,
  },

  financing: {
    recursos_proprios: 0,
    prazo_anos: 7,
    juros_aa: 0.005, // 0.5% used in spreadsheet model (per semester conversion not included here; we treat as rate per period in calc = juros_aa/2)
    carencia_meses: 36,
    rebate: 0.43396,
    remun_ater_pct: 0.05,
    ater_financiada: "sim",
    parcelas_tipo: "Semestral",
    bens_remanescentes: "Sim",
    // calculated fields
    total_orcamento_ater: 0,
    total_financiamento: 0,
    remuneracao_ater: 0,
    parcela_anual_remun_ater: 0,
  },

  reimbursement_schedule: [],

  plot: {
    matricula: "",
    numero_lote: "",
    municipio: "",
    distrito: "",
    area_total: 0,
    area_utilizada: 0,
    area_lavouras: 0,
    area_pastagem: 0,
    area_reflorestamento: 0,
    localizacao: "",
    roteiro: "",
  },

  infrastructure: {
    benfeitorias: [],
    maquinas: [],
    rebanho: [],
    valor_total_bens: 0,
  },

  production: {
    lavouras: [
      { produto: "Soja", unidade: "kg", prod_ano1: 0, area_ano1: 0, prod_ano2: 0, area_ano2: 0, prod_ano3: 0, area_ano3: 0, prod_seguintes: 0, area_seguintes: 0 },
      { produto: "Milho", unidade: "kg", prod_ano1: 0, area_ano1: 0, prod_ano2: 0, area_ano2: 0, prod_ano3: 0, area_ano3: 0, prod_seguintes: 0, area_seguintes: 0 },
    ],
    pecuaria: [
      { produto: "Leite", unidade: "l", qtd_ano1: 0, area_ano1: 0, qtd_ano2: 0, area_ano2: 0, qtd_ano3: 0, area_ano3: 0, qtd_seguintes: 0, area_seguintes: 0 },
    ],
  },

  non_agri_revenue: [],
  family_maintenance_annual: 0,

  laudo: { items: [], descricao_pormenorizada: "" },

  recommendations: {
    recomendacoes_capag: "",
    comercializacao: "",
    recomendacoes_gerais: "",
    orientacao_ambiental:
      "Declaro ter prestado ao beneficiário orientação técnica sobre a legislação ambiental aplicável.",
    compromisso_tecnico:
      "Assumo, como profissional habilitado, o compromisso técnico pela elaboração e acompanhamento deste projeto.",
    observacoes: "",
  },

  cash_flow: {
    receitas_agricolas_anuais: Array(10).fill(0),
    receitas_pecuarias_anuais: Array(10).fill(0),
    receitas_outras_anuais: Array(10).fill(0),
    despesas_agricolas_anuais: Array(10).fill(0),
    despesas_pecuarias_anuais: Array(10).fill(0),
    despesas_outras_anuais: Array(10).fill(0),
    dividas_anuais: Array(10).fill(0),
    custos_fixos_anuais: Array(10).fill(0),
    manutencao_familiar_anuais: Array(10).fill(0),
  },

  cash_flow_calc: { years: 10, rows: [] },
};

export const STEPS = [
  { id: "basic", label: "Dados Básicos", short: "1. Dados" },
  { id: "credit", label: "Crédito a Aplicar", short: "2. Crédito" },
  { id: "financing", label: "Condições do Financiamento", short: "3. Financiamento" },
  { id: "schedule", label: "Reembolso Programado", short: "4. Reembolso" },
  { id: "plot", label: "Identificação do Lote", short: "5. Lote" },
  { id: "infra", label: "Infraestrutura", short: "6. Infraestrutura" },
  { id: "production", label: "Produção Prevista", short: "7. Produção" },
  { id: "non_agri", label: "Receitas Não Agropecuárias", short: "8. Outras Receitas" },
  { id: "family", label: "Manutenção Familiar", short: "9. Família" },
  { id: "laudo", label: "Laudo / Parcela Anterior", short: "10. Laudo" },
  { id: "recs", label: "Recomendações Técnicas", short: "11. Técnicas" },
  { id: "cashflow", label: "Fluxo de Caixa / CAPAG", short: "12. Fluxo de Caixa" },
];

export function formatBRL(v) {
  const n = Number(v || 0);
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatNumber(v, decimals = 2) {
  const n = Number(v || 0);
  return n.toLocaleString("pt-BR", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}
